import { render, staticRenderFns } from "./AgriculturalMaterials.vue?vue&type=template&id=b6b38d72&scoped=true"
import script from "./AgriculturalMaterials.vue?vue&type=script&lang=js"
export * from "./AgriculturalMaterials.vue?vue&type=script&lang=js"
import style0 from "./AgriculturalMaterials.vue?vue&type=style&index=0&id=b6b38d72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b38d72",
  null
  
)

export default component.exports